var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-0 entregas-graphs",attrs:{"fluid":""}},[(_vm.loading)?_c('v-row',[_c('v-col',[_c('div',{staticClass:"d-flex flex-column align-center justify-center loading-container rounded-lg pa-3 text-center py-8"},[_c('v-progress-circular',{attrs:{"size":70,"width":4,"color":"#5e85ef","indeterminate":""}}),_c('p',{staticClass:"mb-0 mt-5 text--disabled"},[_vm._v("Cargando Información")])],1)])],1):_c('div',[_c('div',{staticClass:"dashboard-header mb-6"},[_c('div',{staticClass:"header-text"},[_c('span',{staticClass:"header-eyebrow"},[_vm._v("Panel de entregas")]),_c('h2',{staticClass:"header-title"},[_vm._v("Resumen de Entregas")]),_c('p',{staticClass:"header-subtitle"},[_vm._v("Visualiza el estado y avance general de las entregas del proyecto")])]),_c('v-btn',{staticClass:"export-btn",attrs:{"color":"#5E85EF","dark":"","depressed":"","small":"","loading":_vm.exportingPdf,"disabled":_vm.exportingPdf || !_vm.$store.projectsStore.state.selectedProject},on:{"click":_vm.exportGraphsPDF}},[_c('v-icon',{attrs:{"left":"","size":"16"}},[_vm._v("mdi-file-pdf-box")]),_vm._v(" Exportar PDF ")],1)],1),_c('div',{staticClass:"stats-grid mb-6"},_vm._l((_vm.statCardsConfig),function(card){return _c('div',{key:card.key,staticClass:"stat-card",style:({ '--accent': card.color })},[_c('div',{staticClass:"stat-icon-wrap",style:({ background: card.bg })},[_c('v-icon',{attrs:{"color":card.color,"size":"22"}},[_vm._v(_vm._s(card.icon))])],1),_c('div',{staticClass:"stat-body"},[_c('h3',{staticClass:"stat-value"},[_vm._v(_vm._s(card.value))]),_c('p',{staticClass:"stat-label"},[_vm._v(_vm._s(card.label))])])])}),0),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('div',{staticClass:"chart-card",style:({ '--chart-accent': '#5E85EF' })},[_c('div',{staticClass:"chart-card-header"},[_c('div',{staticClass:"chart-header-icon",style:({ background: '#5E85EF1A' })},[_c('v-icon',{attrs:{"color":"#5E85EF","size":"20"}},[_vm._v("mdi-chart-pie")])],1),_c('div',{staticClass:"chart-header-text"},[_c('h3',{staticClass:"chart-title"},[_vm._v("Entregas por Estado")]),_c('p',{staticClass:"chart-subtitle"},[_vm._v("Distribución de entregas según su estado actual")])])]),_c('div',{staticClass:"chart-body"},[(_vm.chartData.statusDistribution.labels.length > 0)?_c('DoughnutChart',{attrs:{"chartdata":{
						labels: _vm.statusDistributionChartLabels,
						datasets: [
							{
								backgroundColor: _vm.chartData.statusDistribution.colors,
								data: _vm.chartData.statusDistribution.data
							}
						]
					},"options":{
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							datalabels: {
								anchor: 'center',
								align: 'center',
								color: _vm.getDataLabelColor,
								display: _vm.displayDataLabel,
								font: {
									weight: 'bold',
									size: 12
								},
								formatter: _vm.formatDataLabel
							}
						},
						legend: {
						position: 'right',
						labels: {
							padding: 20,
							boxWidth: 10
						}
						}
					},"height":250,"showDataLabels":true}}):_c('div',{staticClass:"empty-chart-message"},[_c('v-icon',{attrs:{"color":"#C7CDD9","size":"48"}},[_vm._v("mdi-chart-pie")]),_c('p',[_vm._v("No hay datos disponibles")])],1)],1)])]),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('div',{staticClass:"chart-card",style:({ '--chart-accent': '#EAB261' })},[_c('div',{staticClass:"chart-card-header"},[_c('div',{staticClass:"chart-header-icon",style:({ background: '#EAB2611A' })},[_c('v-icon',{attrs:{"color":"#EAB261","size":"20"}},[_vm._v("mdi-chart-timeline-variant")])],1),_c('div',{staticClass:"chart-header-text"},[_c('h3',{staticClass:"chart-title"},[_vm._v("Tiempo Promedio de Aprobación")]),_c('p',{staticClass:"chart-subtitle"},[_vm._v("Días promedio hasta la aprobación por especialidad")])])]),_c('div',{staticClass:"chart-body"},[(_vm.chartData.approvalTime.labels.length > 0)?_c('BarChart',{attrs:{"chartdata":{
						labels: _vm.chartData.approvalTime.labels,
						datasets: [
						{
							backgroundColor: _vm.chartData.approvalTime.colors,
							label: 'Días',
							data: _vm.chartData.approvalTime.data
						}
						]
					},"options":{
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							datalabels: {
								anchor: 'center',
								align: 'center',
								color: _vm.getDataLabelColor,
								display: _vm.displayDataLabel,
								font: {
									weight: 'bold',
									size: 11
								},
								formatter: _vm.formatDataLabel
							}
						},
						legend: {
						display: false
						},
						scales: {
						yAxes: [{
							ticks: {
							beginAtZero: true
							}
						}]
						}
					},"height":250,"showDataLabels":true}}):_c('div',{staticClass:"empty-chart-message"},[_c('v-icon',{attrs:{"color":"#C7CDD9","size":"48"}},[_vm._v("mdi-chart-timeline")]),_c('p',[_vm._v("No hay datos disponibles")])],1)],1)])]),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('div',{staticClass:"chart-card",style:({ '--chart-accent': '#9C27B0' })},[_c('div',{staticClass:"chart-card-header"},[_c('div',{staticClass:"chart-header-icon",style:({ background: '#9C27B01A' })},[_c('v-icon',{attrs:{"color":"#9C27B0","size":"20"}},[_vm._v("mdi-account-group")])],1),_c('div',{staticClass:"chart-header-text"},[_c('h3',{staticClass:"chart-title"},[_vm._v("Aprobaciones por Perfil")]),_c('p',{staticClass:"chart-subtitle"},[_vm._v("Entregas únicas por estado según perfil del aprobador")])])]),_c('div',{staticClass:"chart-body"},[(_vm.chartData.approvalsByJobType.labels.length > 0)?_c('HorizontalBarChart',{attrs:{"chartdata":{
						labels: _vm.chartData.approvalsByJobType.labels,
						datasets: [
						{
							backgroundColor: '#EAB261',
							label: 'Aprobadas',
							data: _vm.chartData.approvalsByJobType.approved
						},
						{
							backgroundColor: '#F45771',
							label: 'Rechazadas',
							data: _vm.chartData.approvalsByJobType.rejected
						},
						{
							backgroundColor: '#9E9E9E',
							label: 'Observadas',
							data: _vm.chartData.approvalsByJobType.observed
						}
						]
					},"options":{
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							datalabels: {
								anchor: 'center',
								align: 'center',
								color: _vm.getDataLabelColor,
								clamp: true,
								display: _vm.displayDataLabel,
								font: {
									weight: 'bold',
									size: 11
								},
								formatter: _vm.formatDataLabel
							}
						},
						legend: {
						position: 'top',
						labels: {
							boxWidth: 10
						}
						},
						scales: {
						xAxes: [{
							stacked: true,
							ticks: {
							beginAtZero: true
							}
						}],
						yAxes: [{
							stacked: true
						}]
						}
					},"height":250,"showDataLabels":true}}):_c('div',{staticClass:"empty-chart-message"},[_c('v-icon',{attrs:{"color":"#C7CDD9","size":"48"}},[_vm._v("mdi-account-group")]),_c('p',[_vm._v("No hay datos disponibles")])],1)],1)])]),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('div',{staticClass:"chart-card",style:({ '--chart-accent': '#2D4B95' })},[_c('div',{staticClass:"chart-card-header"},[_c('div',{staticClass:"chart-header-icon",style:({ background: '#2D4B951A' })},[_c('v-icon',{attrs:{"color":"#2D4B95","size":"20"}},[_vm._v("mdi-account")])],1),_c('div',{staticClass:"chart-header-text"},[_c('h3',{staticClass:"chart-title"},[_vm._v("Aprobaciones por Usuario")]),_c('p',{staticClass:"chart-subtitle"},[_vm._v("Entregas únicas por estado según usuario del proyecto")])])]),_c('div',{staticClass:"chart-body"},[(_vm.chartData.approvalsByUser.labels.length > 0)?_c('HorizontalBarChart',{attrs:{"chartdata":{
						labels: _vm.chartData.approvalsByUser.labels,
						datasets: [
						{
							backgroundColor: '#EAB261',
							label: 'Aprobadas',
							data: _vm.chartData.approvalsByUser.approved
						},
						{
							backgroundColor: '#F45771',
							label: 'Rechazadas',
							data: _vm.chartData.approvalsByUser.rejected
						},
						{
							backgroundColor: '#9E9E9E',
							label: 'Observadas',
							data: _vm.chartData.approvalsByUser.observed
						}
						]
					},"options":{
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							datalabels: {
								anchor: 'center',
								align: 'center',
								color: _vm.getDataLabelColor,
								clamp: true,
								display: _vm.displayDataLabel,
								font: {
									weight: 'bold',
									size: 11
								},
								formatter: _vm.formatDataLabel
							}
						},
						legend: {
						position: 'top',
						labels: {
							boxWidth: 10
						}
						},
						scales: {
						xAxes: [{
							stacked: true,
							ticks: {
							beginAtZero: true
							}
						}],
						yAxes: [{
							stacked: true
						}]
						}
					},"height":250,"showDataLabels":true}}):_c('div',{staticClass:"empty-chart-message"},[_c('v-icon',{attrs:{"color":"#C7CDD9","size":"48"}},[_vm._v("mdi-account")]),_c('p',[_vm._v("No hay datos disponibles")])],1)],1)])]),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('div',{staticClass:"chart-card",style:({ '--chart-accent': '#5E85EF' })},[_c('div',{staticClass:"chart-card-header"},[_c('div',{staticClass:"chart-header-icon",style:({ background: '#5E85EF1A' })},[_c('v-icon',{attrs:{"color":"#5E85EF","size":"20"}},[_vm._v("mdi-chart-line")])],1),_c('div',{staticClass:"chart-header-text"},[_c('h3',{staticClass:"chart-title"},[_vm._v("Tendencia Mensual de Entregas")]),_c('p',{staticClass:"chart-subtitle"},[_vm._v("Número de entregas creadas por mes")])])]),_c('div',{staticClass:"chart-body"},[(_vm.chartData.monthlyTrend.labels.length > 0)?_c('LineChart',{attrs:{"chartdata":{
						labels: _vm.chartData.monthlyTrend.labels,
						datasets: [
						{
							label: 'Entregas',
							borderColor: '#5E85EF',
							backgroundColor: 'rgba(94, 133, 239, 0.2)',
							data: _vm.chartData.monthlyTrend.data,
							fill: true
						}
						]
					},"options":{
						responsive: true,
						maintainAspectRatio: false,
						legend: {
						display: false
						},
						elements: {
						line: {
							tension: 0.4
						},
						point: {
							radius: 4
						}
						},
						scales: {
						yAxes: [{
							ticks: {
							beginAtZero: true,
							precision: 0
							}
						}]
						}
					},"height":250}}):_c('div',{staticClass:"empty-chart-message"},[_c('v-icon',{attrs:{"color":"#C7CDD9","size":"48"}},[_vm._v("mdi-chart-line")]),_c('p',[_vm._v("No hay datos disponibles")])],1)],1)])]),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('div',{staticClass:"chart-card",style:({ '--chart-accent': '#009688' })},[_c('div',{staticClass:"chart-card-header"},[_c('div',{staticClass:"chart-header-icon",style:({ background: '#0096881A' })},[_c('v-icon',{attrs:{"color":"#009688","size":"20"}},[_vm._v("mdi-map-marker-radius")])],1),_c('div',{staticClass:"chart-header-text"},[_c('h3',{staticClass:"chart-title"},[_vm._v("Distribución por Zona")]),_c('p',{staticClass:"chart-subtitle"},[_vm._v("Cantidad de entregas por zona del proyecto")])])]),_c('div',{staticClass:"chart-body"},[(_vm.chartData.zoneDistribution.labels.length > 0)?_c('PolarAreaChart',{attrs:{"chartdata":{
						labels: _vm.chartData.zoneDistribution.labels,
						datasets: [
						{
							backgroundColor: _vm.chartData.zoneDistribution.colors,
							data: _vm.chartData.zoneDistribution.data
						}
						]
					},"options":{
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							datalabels: {
								anchor: 'center',
								align: 'center',
								color: _vm.getDataLabelColor,
								clamp: true,
								display: _vm.displayDataLabel,
								font: {
									weight: 'bold',
									size: 12
								},
								formatter: _vm.formatDataLabel
							}
						},
						legend: {
						position: 'right',
						labels: {
							padding: 20,
							boxWidth: 10
						}
						},
						scale: {
						ticks: {
							beginAtZero: true
						}
						}
					},"height":250,"showDataLabels":true}}):_c('div',{staticClass:"empty-chart-message"},[_c('v-icon',{attrs:{"color":"#C7CDD9","size":"48"}},[_vm._v("mdi-map-marker-radius")]),_c('p',[_vm._v("No hay datos disponibles")])],1)],1)])]),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('div',{staticClass:"chart-card",style:({ '--chart-accent': '#8BC34A' })},[_c('div',{staticClass:"chart-card-header"},[_c('div',{staticClass:"chart-header-icon",style:({ background: '#8BC34A1A' })},[_c('v-icon',{attrs:{"color":"#8BC34A","size":"20"}},[_vm._v("mdi-format-list-bulleted-type")])],1),_c('div',{staticClass:"chart-header-text"},[_c('h3',{staticClass:"chart-title"},[_vm._v("Entregas por Especialidad")]),_c('p',{staticClass:"chart-subtitle"},[_vm._v("Entregas únicas por estado dentro de cada especialidad")])])]),_c('div',{staticClass:"chart-body"},[(_vm.chartData.deliveriesBySpecialty.labels.length > 0)?_c('HorizontalBarChart',{attrs:{"chartdata":{
																											labels: _vm.chartData.deliveriesBySpecialty.labels,
						datasets: [
						{
							backgroundColor: '#EAB261',
							label: 'Aprobadas',
							data: _vm.chartData.deliveriesBySpecialty.approved
						},
						{
							backgroundColor: '#F45771',
							label: 'Rechazadas',
							data: _vm.chartData.deliveriesBySpecialty.rejected
						},
						{
							backgroundColor: '#9E9E9E',
							label: 'Observadas',
							data: _vm.chartData.deliveriesBySpecialty.observed
						},
						{
							backgroundColor: '#90A4AE',
							label: 'Pendientes',
							data: _vm.chartData.deliveriesBySpecialty.pending
						}
						]
					},"options":{
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							datalabels: {
								anchor: 'center',
								align: 'center',
								color: _vm.getDataLabelColor,
								clamp: true,
								display: _vm.displayDataLabel,
								font: {
									weight: 'bold',
									size: 11
								},
								formatter: _vm.formatDataLabel
							}
						},
						legend: {
							position: 'top',
							labels: {
								boxWidth: 10
							}
						},
						scales: {
						xAxes: [{
							stacked: true,
							ticks: {
								beginAtZero: true
							}
						}],
						yAxes: [{
							stacked: true
						}]
						}
					},"height":250,"showDataLabels":true}}):_c('div',{staticClass:"empty-chart-message"},[_c('v-icon',{attrs:{"color":"#C7CDD9","size":"48"}},[_vm._v("mdi-format-list-bulleted-type")]),_c('p',[_vm._v("No hay datos disponibles")])],1)],1)])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }